import React from 'react';
import Styled from './style';

const ToolTip = ({
    title = '',
    children,
    placement = 'top',
    ...rest
}) => {
    return <Styled.CustomToolTip {...rest} title={title} arrow placement={placement}>{children}</Styled.CustomToolTip>
}

export default ToolTip;